import React from 'react'
import _ from 'lodash'
import ReactModal from 'react-modal'
import NavigationBar from '../Commons/NavigationBar'
import moment from 'moment'
import * as request from 'superagent'
import { getToken } from '../Commons/Authentication'
import DashboardBasicData from './DashboardBasicData'
import { hashHistory } from 'react-router'
import PatientData from '../../img/icons/general-icons/icon_data.png'
import DashboardSpecialCondition from './DashboardSpecialCondition'
import DashboardMedicalData from './DashboardMedicalData'
import DashboardRiskFactors from './DashboardRiskFactors'
import DashboardSeveritySection from './DashboardSeveritySection'
import DashboardChartComponent from './DashboardChartComponent'
import DashboardHealthSquaresComponent from './DashboardHealthSquaresComponent'

import { ToastContainer, ToastMessage } from 'react-toastr'
import closeModal from '../../img/icons/general-icons/close.png'
import {Typeahead} from 'react-bootstrap-typeahead'

import apiEndPoints from './apiEndPoints'
const ToastMessageFactory = React.createFactory(ToastMessage.animation)
export default class PatientDashboard extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({
      id: '',
      isDataLoad: false,
      codigo_cie_10: '',
      date_muerte: '',
      muerto: false,
      data: {
        showModalEdit: false,
        patientImage: '',
        patientData: {},
        patientFullName: '',
        patientnumeroDocumento: '',
        patientIdentification: '',
        patientAge: '',
        patientGender: '',
        patientBirthDay: '',
        medicalData: {},
        medicalPAParado: '',
        medicalPASentado: '',
        medicalFrecuenciaC: '',
        medicalBalanceNeur: '',
        medicalPeso: '',
        medicalBMIData: '',
        medicalColTotal: '',
        medicalColLDL: '',
        medicalColHDL: '',
        medicalColTrigliceridos: '',
        medicalCreatinina: '',
        medicalCol: '',
        chart1: [0, 0, 0, 0, 0],
        chart2: [0, 0, 0, 0, 0],
        percent_lost_capacity: 0,
        fx_reserve: 0,
        arterialAge: 0,
        biologicalAge: 0
      },
      afectoData: {},
      indiceDeReservaFuncional: {},
      reservaFuncional: {},
      edadArterial: 0,
      edadBiologica: 0,
      estadoSaludData: [],
      print: true
    })
  }

  componentDidMount () {
    this.findPatientDashboard()
    // this.findChartData()
    // this.findEstadoSalud()
    this.findCie10()
  }
  findAfecto () {
    let data = this.state.health
    request
    .get('api/v1/affection/')
    .query({health: data._id, sort: -1, limit: 1})
    .set('Authorization', 'Bearer ' + getToken())
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (err || !res.ok) {
        console.log('Error: ', err, 'And respo: ', res)
      } else {
        if (_.isEmpty(res.body)) {
          this.setState({ afecto: false })
        } else {
          if (res.body.msg == 'no hay resultado')
            this.setState({ afecto: false })
          else
            this.setState({ afecto: true, afectoData: res.body })
        }
      }
    })
  }
  findPatientDashboard () {
    let identificacion = this.props.params.patient
    request
      .get('api/v1/patient/find?numeroDocumento=' + identificacion)
      .set('Authorization', 'Bearer ' + getToken())
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || !res.ok) {
          console.log('Error: ', err, 'And respo: ', res)
        } else {
          let result = res.body[0]

          var birthday = new Date(result.fechaNacimiento.split('/').reverse().join('-'))
          var ageDifMs = Date.now() - birthday.getTime()
          var ageDate = new Date(ageDifMs)
          var age = Math.abs(ageDate.getUTCFullYear() - 1970)
          var newData = this.state.data
          newData.patientImage = result.image
          newData.patientGender = result.genero
          newData.patientBirthDay = moment(result.fechaNacimiento).format('DD/MM/YYYY')
          newData.patientFullName = result.nombres + ' ' + result.apellidos
          newData.numeroDocumento = result.numeroDocumento
          newData.patientIdentification = result.tipoDocumento + ' ' + newData.numeroDocumento
          newData.patientAge = age
          newData.patientData = result
          let date_muerte = String(moment(result.date_muerte).format('YYYY-MM-DD'))
          let muerto = result.muerto
          let descripcion = ''
          newData.muerto = muerto
          newData.date_muerte = date_muerte

          try {
            descripcion = result.codigo_cie_muerte ? [`(${result.codigo_cie_muerte}) ${result.descripcion_codigo_cie}`] : ''
          } catch (e) {
            console.log(e, 'error en descripcion 102')
          }

          this.setState({
            date_muerte: date_muerte,
            muerto: result.muerto,
            'codigo_cie_10': descripcion,
            'codigo_cie': result.codigo_cie_muerte,
            'descripcion': result.descripcion_codigo_cie,
            'id': result._id,
            data: newData
          })
        }
        this.findChartData()
      })
  }
  deathController (e) {
    e.preventDefault()
    this.setState({showModalEdit: true})
  }
  handleInputChange (event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState({
      [name]: value
    })
  }
  medicalDataCapture (e) {
    e.preventDefault()
    let age = this.state.data.patientAge
    let url = 'health/' + this.props.params.patient
    if (age < 21 || age > 80) {
      this.refs.container.warning('Paciente con un rango de edad donde los cálculos no son exactos', '', {
        closeButton: true
      })
      setTimeout(() => { hashHistory.push(url) }, 3600)
    } else {
      hashHistory.push(url)
    }
  }
  closeModal (e) {
    e.preventDefault()
    this.setState({showModalEdit: false})
  }

  // acaaaaa//
  findEstadoSalud () {
    let patientId = this.state.data.patientData._id
    request
      .get(apiEndPoints.findEstadoSaludData(patientId))
      .set('Authorization', 'Bearer ' + getToken())
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err) {
          console.log(err)
          return
        }
        let data = res.body
        if (data.length === 0) {
          data = this.createEmptyDataPatient()
        }

        this.setState({
          estadoSaludData: data,
          isDataLoad: true
        })
      })
  }

  onChangeCie10 (event) {
    let cloneEvent = event
    let cie_descripcion = ''
    let codigo_cie = ''
    let descripcion = ''
    if (event != '' && event) {
      cie_descripcion = cloneEvent[0].split(') ')
      codigo_cie = cie_descripcion[0].replace('(', '')
      descripcion = cie_descripcion[1]
    }

    this.setState({'codigo_cie_10': event, codigo_cie: codigo_cie, descripcion: descripcion})
  }
  findCie10 (event) {
    let endpoint = '/api/v1/pathology/'
    request
    .get(endpoint)
    .set('Authorization', 'Bearer ' + getToken())
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (res.body) {
        let arr = res.body.map((e) => { return `(${e.codigo_cie}) ${e.descripcion}` })
        this.setState({arr: arr})
      }
    })
  }

  createEmptyDataPatient () {
    const emptyData = [{
      diastoleSentado: 0,
      diastoleParado: 0,
      sistoleSentado: 0,
      sistoleParado: 0,
      imc: 0,
      perimetroAbdominal: 0,
      balanceNeuroMuscularIzquierdo: 0,
      balanceNeuroMuscularDerecho: 0,
      balanceNeuroMuscularT: 0,
      gripIzquierdo: 0,
      gripDerecho: 0,
      gripT: 0,
      itbIzquierdo: 0,
      itbDerecho: 0,
      vop: 0,
      temperatura: 0,
      salud: 0,
      notas: '',
      frecuencia: 0,
      tiempoCincoM: 0,
      mets: 0,
      depresion: 0,
      satisfaccion: 0,
      feliz: 0,
      preocupacion: 0,
      decaido: 0,
      gender: '',
      peso: 0,
      altura: 0,
      fechaNacimiento: null,
      fuma: '',
      movilidad: 0,
      cuidadoPersonal: 0,
      actividadesCotidianas: 0,
      dolor: 0,
      ansiedad: 0,
      paciente: null,
      versionAlgoritmo: '',
      fechaDeTomaDeDatos: null,
      usuarioCreacion: null,
      usuarioUltimaModificacion: null,
      toma: 0,
      intervaloATomaAnterior: 0,
      intervaloATomaBase: 0,
      timeUpdate: null,
      timestamp: null,
      dateDashboard: null
    }]
    return emptyData
  }

  createEmptyDataCalculated () {
    const emptyData = {
      edadArterial: 0,
      edadBiologica: 0,
      reservaFuncional: {
        capacidadFuncional: 0,
        perdidaCapacidadFuncional: 0
      },
      indiceDeReservaFuncional: {
        vigorNeuromuscular: 0,
        balanceAfectivoYBienestar: 0,
        fxCardioPulmonar: 0,
        fxMetabolica: 0,
        fxArterial: 0
      },
      fechaDelCalculo: null,
      versionAlgoritmo: null,
      paciente: null,
      estadoDeSaludData: {imc: null},
      dateDashboard: ""
    }

    return emptyData
  }
  handleCloseModal () {
    this.setState({showModalEditConfirm: false, showModalEdit: false})
  }
  hangleChangeDate () {
    this.setState({date_muerte: this.refs.date_muerte.value})
  }
  handleSaveConfirm () {
    this.setState({showModalEditConfirm: false})
    let newData = this.state

    let updatePatient = {id: this.state.data.patientData.id, muerto: this.state.muerto, codigo_cie_muerte: this.state.codigo_cie, descripcion_codigo_cie: this.state.descripcion, date_muerte: this.state.date_muerte }
    let endpoint = '/api/v1/patient/'
    request
    .put(endpoint)
    .set('Authorization', 'Bearer ' + getToken())
    .set('Accept', 'application/json')
    .send(updatePatient)
    .end((err, res) => {
      if (res) {
        let data = {}
        this.setState({showModalEdit: false})
      }
    })
  }

  findChartData () {
    const patientId = this.state.data.patientData._id
    request
    .get(apiEndPoints.findCalulatesForPatientId(patientId))
    .set('Authorization', 'Bearer ' + getToken())
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (err) {
        console.log(err)
        return
      }
      let data = res.body
      if (_.isEmpty(data)) {
        data = this.createEmptyDataCalculated()
      }
      let animate = data.indiceDeReservaFuncional.balanceAfectivoYBienestar < 7
      let ShowAfecto = data.indiceDeReservaFuncional.balanceAfectivoYBienestar > 0 && data.estadoDeSaludData
      
      let newData = this.state.data
      newData.chart1 = [data.indiceDeReservaFuncional.fxArterial, data.indiceDeReservaFuncional.fxMetabolica, data.indiceDeReservaFuncional.fxCardioPulmonar, data.indiceDeReservaFuncional.balanceAfectivoYBienestar, data.indiceDeReservaFuncional.vigorNeuromuscular]

      newData.percent_lost_capacity = data.reservaFuncional.perdidaCapacidadFuncional
      newData.fx_reserve = data.reservaFuncional.capacidadFuncional
      newData.arterialAge = data.edadArterial
      newData.biologicalAge = data.edadBiologica
      newData.medicalBMIData = data.estadoDeSaludData.imc

      let dateDashboard = moment(data.timestamp, 'x').format("DD/MM/YYYY")

      let gripT = (data.estadoDeSaludData.gripi+data.estadoDeSaludData.gripd)/2
      if ((data.estadoDeSaludData.balanceNeuroMuscularIzquierdo > 0 && data.estadoDeSaludData.balanceNeuroMuscularDerecho > 0) && (data.estadoDeSaludData.gripi > 0 && data.estadoDeSaludData.gripd > 0)) {
        console.log('primer if')
        newData.medicalData.balanceNeuroMuscularT = Math.max(gripT, (data.estadoDeSaludData.balanceNeuroMuscularIzquierdo + data.estadoDeSaludData.balanceNeuroMuscularDerecho)/2)
      } else {
        if (data.estadoDeSaludData.balanceNeuroMuscularIzquierdo > 0 && data.estadoDeSaludData.balanceNeuroMuscularDerecho > 0) {
          console.log('2do if')
          newData.medicalData.balanceNeuroMuscularT = (data.estadoDeSaludData.balanceNeuroMuscularIzquierdo + data.estadoDeSaludData.balanceNeuroMuscularDerecho)/2
        } else if (data.estadoDeSaludData.gripi > 0 && data.estadoDeSaludData.gripd > 0) {
          console.log('3er if')
          newData.medicalData.balanceNeuroMuscularT = gripT
        } else {
          console.log('4to if')
          newData.medicalData.balanceNeuroMuscularT = Math.max(data.estadoDeSaludData.balanceNeuroMuscularIzquierdo, data.estadoDeSaludData.balanceNeuroMuscularDerecho, data.estadoDeSaludData.gripi, data.estadoDeSaludData.gripd)
        }
      }
      // newData.medicalData.balanceNeuroMuscularT = data.estadoDeSaludData.balanceNeuroMuscularT
      newData.medicalData.satisfaccion = data.estadoDeSaludData.satisfaccion
      newData.medicalData.depresion = data.estadoDeSaludData.depresion
      newData.medicalData.feliz = data.estadoDeSaludData.feliz
      newData.medicalFrecuenciaC = data.estadoDeSaludData.frecuencia
      newData.medicalData.preocupacion = data.estadoDeSaludData.preocupacion
      newData.medicalData.decaido = data.estadoDeSaludData.decaido
      newData.medicalData.mets = data.estadoDeSaludData.mets
      newData.medicalData.movilidad = data.estadoDeSaludData.movilidad
      newData.medicalData.cuidadoPersonal = data.estadoDeSaludData.cuidadoPersonal
      newData.medicalData.actividadesCotidianas = data.estadoDeSaludData.actividadesCotidianas
      newData.medicalData.dolor = data.estadoDeSaludData.dolor
      newData.medicalData.ansiedad = data.estadoDeSaludData.ansiedad
      newData.medicalData.tiempoCincoM = data.estadoDeSaludData.tiempoCincoM
      newData.medicalData.altura = data.estadoDeSaludData.altura
      newData.medicalData.peso = data.estadoDeSaludData.peso
      newData.medicalData.fuma = data.estadoDeSaludData.fuma
      newData.fuma = data.estadoDeSaludData.fuma

      this.setState({
        indiceDeReservaFuncional: data.indiceDeReservaFuncional,
        reservaFuncional: data.reservaFuncional,
        edadArterial: data.edadArterial,
        edadBiologica: data.edadBiologica,
        health: data.estadoDeSaludData,
        animate,
        ShowAfecto,
        dateDashboard
      })
      this.findAfecto()
      this.findEstadoSalud()
    })
  }

  saveStatePatient () {
    this.setState({showModalEditConfirm: true })
  }

  render () {
    let {data, estadoSaludData} = this.state
    let risk = {data, estadoSaludData}
    if (!this.state.isDataLoad) return (
        <div className="all">
          <div className='loader'></div>
        </div>
    )
    document.title = 'Dashboard - CORE 3.0'
    var myData = [
      'John',
      'Miles',
      'Charles',
      'Herbie'
    ]
    if (this.state.arr) {
      myData = this.state.arr
    }
    return (
      <div className='dashboard-container'>
      <ReactModal
      className='edit-patient'
      isOpen={this.state.showModalEdit}
      contentLabel="Editar Estado del paciente."
      overlayClassName="Overlay"
      >
      <div className="header-modal-section-close">
          <img className="closeModalIcon" src={closeModal} onClick={this.closeModal.bind(this)}/>
      </div>
        <div className='container-modal'>
          <div className='checkbox'>
            <span>Fallecido </span>
            <input name="muerto"
            type="checkbox"
            checked={this.state.muerto}
            onChange={this.handleInputChange.bind(this)}/>
            </div>
            <div className='col-span'>
              Código Cie 10.
              <br/>
              <Typeahead className='typeahead-boostrap' options={myData} onChange={this.onChangeCie10.bind(this)} placeholder="Elige un código cie 10" selected={this.state.codigo_cie_10}/>
            </div>
            <div className='col-span'>
              Fecha.
              <br/>
              <input className='date_muerte' ref='date_muerte' value={this.state.date_muerte} type='date' onChange={this.hangleChangeDate.bind(this)}/>
            </div>
            <div className='save-button-'>
            {this.state.codigo_cie_10 && this.state.date_muerte ?
              <div className='save-modal' onClick={this.saveStatePatient.bind(this)}>Guardar</div>
              : ''}
            </div>
            <ReactModal
            className='alert-modal'
            isOpen={this.state.showModalEditConfirm}
            contentLabel="Editar Estado del paciente."
            overlayClassName="Overlay"
            >
                <p className='pAlert'>
                Deseas confirmar el cambio de estado del paciente. Al seleccionar fallecido la información deja de ser editable y deshabilita todas las funciones. Si se quita el rotulo de fallecido se activara nuevamente las funciones.
                </p>
              <div className='buttonAction' onClick={this.handleCloseModal.bind(this)}>Cancelar</div>
              <div className='buttonAction' onClick={this.handleSaveConfirm.bind(this)}>Continuar</div>
            </ReactModal>
          </div>
      </ReactModal>
        <NavigationBar print={this.state.print}/>
        <div className='patient-information-container'>
          <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
          <DashboardBasicData data={this.state.data} state={this.state}/>
          {this.props.params.patient &&
          <DashboardSpecialCondition data={this.state.data} identification={this.props.params.patient} />}
          <div className='medical-link header-medical-data' onClick={this.deathController.bind(this)}>
            <img className='data-image' src={PatientData}/>
            <label className='text-link'>Editar estado del paciente</label>
          </div>
          <div className='medical-link header-medical-data' onClick={this.medicalDataCapture.bind(this)}>
            <img className='data-image' src={PatientData}/>
            <label className='text-link'>Tomar datos</label>
          </div>
          <DashboardMedicalData
            estadoSaludData={this.state.estadoSaludData}
            lastEstadoSalud={this.state.estadoSaludData[0]}
          />
          <DashboardRiskFactors data={risk} />
        </div>
        <div className='dashboard-charts-components'>
          <div className='status-graphics-container'>
            <div className='charts-square-container'>
              <DashboardSeveritySection
                edadArterial={this.state.edadArterial}
                edadBiologica={this.state.edadBiologica}
                dateDashboard={this.state.dateDashboard}
              />

              <DashboardChartComponent
                animate={this.state.animate}
                ShowAfecto={this.state.ShowAfecto}
                id={this.state.id}
                health={this.state.health}
                afecto={this.state.afecto}
                data={this.state.afectoData}
                indiceDeReservaFuncional={this.state.indiceDeReservaFuncional}
                reservaFuncional={this.state.reservaFuncional}
                patient={this.props.params.patient}
              />

            </div>
            <DashboardHealthSquaresComponent
              data={this.state.afectoData}
              edadArterial={this.state.edadArterial}
              reservaFuncional={this.state.reservaFuncional}
              identification={this.props.params.patient}
            />

          </div>

          <div className='timeline-component-container'>
            <iframe src={'timelineEstadoSalud/?patientId=' + this.state.data.patientData._id} width='100%' height='100%' frameBorder='0'></iframe>
          </div>

        </div>

      </div>
    )
  }
}

/* Validate Props */
PatientDashboard.propTypes = {
  params: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/EstaDoSaludDashboard/DashboardComponent.js